import { render } from "./page_04.vue?vue&type=template&id=afd20dcc"
import script from "./page_04.vue?vue&type=script&lang=js"
export * from "./page_04.vue?vue&type=script&lang=js"
script.render = render

export default script